import { render, staticRenderFns } from "./TarjetaComentario.vue?vue&type=template&id=97036172&scoped=true&"
import script from "./TarjetaComentario.vue?vue&type=script&lang=js&"
export * from "./TarjetaComentario.vue?vue&type=script&lang=js&"
import style0 from "./TarjetaComentario.vue?vue&type=style&index=0&id=97036172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97036172",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VTab,
  VTabs,
})
